import React, { FC } from 'react';
import { addProtocol } from '../../../utils/addProtocol';
import { buildImageSource, buildImageSourceSet } from '../../../utils/buildImageSource';
import { formatCurrency } from '../../../utils/format/formatCurrency';
import { useTranslation } from '../../../utils/useTranslation';
import { IconProduct } from '../../icon/IconProduct';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Image } from '../../media/Image';
import { MediaCover } from '../../media/MediaCover';
import { Typography } from '../../typography/Typography';
import { ProductMonetization } from '../ProductMonetization/ProductMonetization';
import { Card, Title } from './styles';
import { PostProductCardProps } from './types';

export const PostProductCard: FC<PostProductCardProps> = ({ product, onProductClick }) => {
    const t = useTranslation();
    const { oldPriceInfo, priceInfo, content, title, url, id, monetizationEnabled } = product;

    const media = content[0]?.media;

    const oldCurrency = oldPriceInfo?.currency;
    const oldIntegerPart = oldPriceInfo?.integerPart;
    const oldFractionalPart = oldPriceInfo?.fractionalPart;
    const integerPart = priceInfo?.integerPart;
    const fractionalPart = priceInfo?.fractionalPart;
    const hasPriceInfo = integerPart !== undefined && integerPart !== null;

    return (
        <Card href={addProtocol(url)} onClick={() => onProductClick(id, url)}>
            {monetizationEnabled ? (
                <Box position="absolute" top={1} left={1} zIndex={1}>
                    <ProductMonetization color="white" />
                </Box>
            ) : null}
            <MediaCover ratio={1} overflow="hidden" borderRadius="20px">
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="var(--background-primary)"
                >
                    {media ? (
                        <Image
                            objectFit="contain"
                            width="100%"
                            height="100%"
                            src={buildImageSource(media)}
                            srcSet={buildImageSourceSet(media)}
                        />
                    ) : (
                        <IconProduct size={72} color="var(--control-secondary-background)" />
                    )}
                </Flex>
            </MediaCover>
            <Box p={1}>
                <Title variant="body2" weight="regular">
                    {t(title)}
                </Title>
                {hasPriceInfo ? (
                    <Flex direction="row" alignItems="baseline">
                        <Typography
                            weight="bold"
                            variant="body"
                            color="var(--control-primary-background)"
                            textTransform="none"
                        >
                            {formatCurrency(integerPart, fractionalPart)}
                        </Typography>
                        {oldCurrency ? (
                            <Typography
                                variant="caption"
                                color="var(--control-disabled-color)"
                                textTransform="none"
                                textDecoration="line-through"
                                ml={1}
                            >
                                {formatCurrency(oldIntegerPart, oldFractionalPart)}
                            </Typography>
                        ) : null}
                    </Flex>
                ) : null}
            </Box>
        </Card>
    );
};
